import { Button, Divider } from "antd";
import { useState } from "react";
import { BreadcrumbIcon, UndoIcon, RedoIcon } from "../../../icons";
import ShareModal from "../Modal/ShareModal";
import { useParams } from "react-router-dom";
import { notification } from "antd";
import "./HeaderPanel.css";
import { TitleEdit } from "../TitleEdit/TitleEdit";
import { ConceptType } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { useGetDashboardListQuery, useSaveDashboardMutation, useUpdateDashboardMutation } from "../../../store/api/lumi/dashboard";

export const HeaderPanel = ({project, name, updateName}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [updatedName, setUpdatedName] = useState('');
    const navigate = useNavigate();
    const [saveDashboard] = useSaveDashboardMutation();
    const [updateDashboard] = useUpdateDashboardMutation();
   
    const shareLink = "https://testlink.com/weekly-portland-grocery";
    const { id } = useParams();
    const currentDashboard = JSON.parse(localStorage.getItem(`dashboardState-${id}`));
    const { data: dashboardList } = useGetDashboardListQuery(id);
    const openShareModal = () => {
    setIsModalOpen(true);
    }

    const handleUpdateDashboard = async (e,name, newName=updatedName) => {

        if (!currentDashboard) {
            notification.error({
                message: "Error Updating Dashboard",
                description: "No dashboard is currently selected for updating.",
            });
            return;
        }

        try {
            const updatedDashboard = {

                name: newName ? newName : name,
                description:  currentDashboard.description,
                charts: currentDashboard.openedWidgets,
                top_filters: currentDashboard.topFilters,
                selections: currentDashboard.selections,
                top_concepts: currentDashboard.topConcepts,
                active_concept_list: currentDashboard.activeConceptList || ConceptType.Top,
            };

            if(dashboardList.find(y => y.name === name)){
            const result = await updateDashboard({
                projectId: id,
                dashboardId: dashboardList.find(y => y.name === name).dashboard_id,
                data: updatedDashboard,
            }).unwrap();
            navigate(`/projects/${id}/dashboard/${result.name}?app=new`);

            updateName(newName ? newName : name);
            setUpdatedName('');
            notification.success({
                message: "Dashboard Updated!",
                description: "Your dashboard has been updated successfully.",
            });} else {
                const result = await saveDashboard({
                    id: id,
                    dashboard: updatedDashboard,
                }).unwrap();
                navigate(`/projects/${id}/dashboard/${result.name}?app=new`);
                updateName(newName ? newName : name);
                setUpdatedName('');
                notification.success({
                    message: "Dashboard Saved!",
                    description: "Your dashboard has been saved successfully.",
                });
            }
        } catch (error) {
            notification.error({
                message: "Error Updating Dashboard",
                description: "There was an error updating your dashboard: " + error.message,
            });
        }
    };
    return (
        <div className="top-header">
            <div className="left-section">
                <div className="folder-container">
                    <span>
                     {project?.name}
                    </span>
                </div>
                <div className="separator-logo">
                    <BreadcrumbIcon height={20} width={20} />
                </div>
                <div className="title-edit">

                    <TitleEdit name={name} 
                    updateDashboard={handleUpdateDashboard} 
                    setUpdatedName={setUpdatedName}
                    />

                </div>
            </div>
            <div className="right-section">
                <div className="button-group">
                    <div className="button-icon">
                        <Button
                            type="text"
                            icon={<UndoIcon height={20} width={20} />}
                        />
                    </div>
                    <div className="button-icon">
                        <Button
                            type="text"
                            icon={<RedoIcon height={20} width={20} />}
                        />
                    </div>
                </div>
                <Divider
                    type="vertical"
                    style={{ height: 40, background: "#E3E9E2" }}
                />
                <Button type="text" onClick={openShareModal}>Share</Button>
                <ShareModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} shareLink={shareLink}/>
                <Button type="primary" onClick={(e) => handleUpdateDashboard(e,name)}>Save</Button>
            </div>
        </div>
    );
};
